export const GET_SHOW_SEASON_REQUEST = 'GET_SHOW_SEASON_REQUEST';
export const GET_SHOW_SEASON_SUCCESS = 'GET_SHOW_SEASON_SUCCESS';
export const GET_SHOW_SEASON_ERROR = 'GET_SHOW_SEASON_ERROR';
export const SET_SHOW_APPLICANTS = 'SET_SHOW_APPLICANTS';
export const SUBMIT_APPLICANTS_REQUEST = 'SUBMIT_APPLICANTS_REQUEST';
export const SUBMIT_APPLICANTS_SUCCESS = 'SUBMIT_APPLICANTS_SUCCESS';
export const SUBMIT_APPLICANTS_ERROR = 'SUBMIT_APPLICANTS_ERROR';



// WEBPACK FOOTER //
// ./src/store/showSeason/showSeasonActionTypes.js